import { render, staticRenderFns } from "./ItemBundlingCreation.vue?vue&type=template&id=62d1024b&"
import script from "./ItemBundlingCreation.vue?vue&type=script&lang=js&"
export * from "./ItemBundlingCreation.vue?vue&type=script&lang=js&"
import style0 from "./ItemBundlingCreation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports